import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { css } from '@emotion/react';
import { borderRadius } from '@atlaskit/theme/constants';
import { getCSSUnitValue } from '../../utils/getCSSUnitValue';
import { breakpointStyles } from '../../utils/breakpoint';
import { getSelectedBorderStyle } from './getSelectedBorderStyle';
import { getDimensionsWithDefault } from '../../utils/lightCards/getDimensionsWithDefault';
export var inlinePlayerClassName = 'media-card-inline-player';
var getWrapperHeight = function getWrapperHeight(dimensions) {
  return dimensions && dimensions.height ? "height: ".concat(getCSSUnitValue(dimensions.height), "; max-height: 100%;") : '';
};
var getWrapperWidth = function getWrapperWidth(dimensions) {
  return dimensions && dimensions.width ? "width: ".concat(getCSSUnitValue(dimensions.width), "; max-width: 100%;") : '';
};
export var wrapperStyles = function wrapperStyles(_ref) {
  var dimensions = _ref.dimensions,
    _ref$breakpointSize = _ref.breakpointSize,
    breakpointSize = _ref$breakpointSize === void 0 ? 'medium' : _ref$breakpointSize,
    shouldUsePointerCursor = _ref.shouldUsePointerCursor;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n      ", "\n  cursor: ", ";\n"])), breakpointStyles({
    breakpointSize: breakpointSize
  }), getWrapperHeight(dimensions), getWrapperWidth(dimensions), shouldUsePointerCursor ? 'pointer' : 'default');
};
wrapperStyles.displayName = 'CardViewWrapper';
export var inlinePlayerWrapperStyles = function inlinePlayerWrapperStyles(_ref2) {
  var dimensions = _ref2.dimensions,
    selected = _ref2.selected;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  overflow: hidden;\n  border-radius: ", "px;\n  position: relative;\n  max-width: 100%;\n  max-height: 100%;\n\n  ", "\n\n  video {\n    width: 100%;\n    height: 100%;\n  }\n"])), getDimensionsWithDefault(dimensions).width || '100%', getDimensionsWithDefault(dimensions).height || 'auto', borderRadius(), getSelectedBorderStyle(selected));
};
inlinePlayerWrapperStyles.displayName = 'InlinePlayerWrapper';